var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _circle, _circle2, _circle3, _circle4, _circle5, _path24, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _rect2, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegionalPanelcolors(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 530 533",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 226,
    height: 230,
    x: 36,
    y: 90,
    fill: "#fff",
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M66.63 120.818l1.274 1.568 1.26-1.064-1.218-1.498c.42-.448.728-.98.952-1.624.21-.644.322-1.372.322-2.198 0-.812-.112-1.54-.322-2.184a4.891 4.891 0 00-.938-1.652 4.204 4.204 0 00-1.484-1.05c-.588-.238-1.26-.364-2.002-.364-.742 0-1.4.126-1.988.364a4.446 4.446 0 00-1.512 1.05c-.42.462-.728 1.008-.952 1.652-.224.644-.322 1.372-.322 2.184s.098 1.54.322 2.184c.224.644.532 1.204.952 1.652.406.462.91.812 1.498 1.05.588.252 1.246.364 2.002.364.798 0 1.512-.14 2.156-.434zm-2.38-2.968l1.218 1.498a2.642 2.642 0 01-.476.126c-.168.028-.35.028-.518.028-.882 0-1.54-.294-1.974-.91-.434-.616-.644-1.47-.644-2.59 0-1.092.21-1.946.644-2.548.434-.602 1.092-.91 1.974-.91.868 0 1.526.308 1.946.91.42.602.644 1.456.644 2.548 0 .952-.14 1.68-.42 2.212l-1.134-1.428-1.26 1.064zm6.486-4.158v4.83c0 .938.195 1.624.587 2.058.393.434.995.644 1.835.644.42 0 .826-.098 1.204-.294.378-.196.714-.504 1.022-.938V121h1.903v-7.308h-1.96v4.396a1.442 1.442 0 01-.49 1.064c-.154.14-.308.252-.475.322-.168.084-.364.112-.616.112-.337 0-.588-.084-.77-.266-.197-.182-.28-.532-.28-1.064v-4.564h-1.96zm12.626 6.384V121h1.848v-4.62c0-.448-.056-.84-.168-1.204a2.3 2.3 0 00-.518-.924c-.238-.252-.546-.434-.938-.574-.392-.14-.868-.21-1.428-.21-.924 0-1.652.182-2.184.518-.546.336-.882.896-1.008 1.652l1.792.168c.112-.588.546-.882 1.33-.882.336 0 .616.084.868.252.252.168.378.476.378.924v.364l-.938.042c-.476.028-.938.07-1.386.14-.448.084-.854.21-1.218.378a2.408 2.408 0 00-.882.742c-.224.322-.336.728-.336 1.232 0 .392.056.714.196.994.126.28.294.504.518.672.224.182.476.308.77.392.294.084.602.126.938.126.56 0 1.022-.098 1.386-.308.364-.196.686-.462.98-.798zm-.042-2.338v.378c0 .308-.056.56-.168.756a1.633 1.633 0 01-.434.49c-.322.238-.728.35-1.232.35-.308 0-.532-.07-.7-.21-.168-.14-.252-.322-.252-.574 0-.154.014-.294.07-.434a.665.665 0 01.266-.336c.14-.098.336-.182.588-.252a6.75 6.75 0 01.994-.126l.868-.042zm3.564-6.734V121h1.96v-9.996h-1.96zm3.719 2.688V121h1.96v-7.308h-1.96zm-.028-2.688v1.764h2.016v-1.764h-2.016zm4.18 4.214v3.416c0 .91.183 1.554.575 1.932.392.392.98.574 1.791.574.225 0 .477-.014.729-.042a4.62 4.62 0 00.797-.182l-.28-1.442c-.14.042-.266.07-.406.084-.14.014-.266.014-.391.014-.252 0-.462-.056-.616-.196-.168-.14-.238-.392-.238-.784v-3.374h1.68v-1.526h-1.68v-1.946h-1.96v1.946h-1.148v1.526h1.147zm5.327 6.818l-.322 1.456c.252.084.504.154.742.182.238.028.476.042.728.042.392 0 .714-.042.98-.154.266-.098.49-.252.686-.462.196-.21.364-.476.518-.784.14-.308.308-.686.476-1.106l2.954-7.518h-2.142l-1.596 4.802-1.708-4.802H99.13l3.038 6.986-.224.616c-.112.322-.252.546-.406.672-.168.126-.378.182-.63.182-.28 0-.56-.028-.826-.112zm14.294-.812a4.11 4.11 0 001.526-.266c.448-.168.84-.434 1.162-.77.322-.336.574-.742.742-1.218a4.899 4.899 0 00.266-1.638c0-.588-.084-1.134-.252-1.61a3.355 3.355 0 00-.742-1.218 3.308 3.308 0 00-1.162-.77 4.497 4.497 0 00-1.54-.266c-.56 0-1.078.098-1.526.266a3.242 3.242 0 00-1.176.77 3.355 3.355 0 00-.742 1.218 4.856 4.856 0 00-.252 1.61c0 1.26.322 2.212.966 2.884.644.672 1.554 1.008 2.73 1.008zm0-1.568c-.574 0-.994-.196-1.26-.588-.28-.392-.406-.98-.406-1.736 0-.742.126-1.316.406-1.708.28-.392.7-.588 1.26-.588s.966.196 1.246.588c.28.392.42.966.42 1.708 0 .756-.14 1.33-.42 1.722-.28.406-.686.602-1.246.602zm5.659-4.438V121h1.96v-5.782h1.694v-1.526h-1.694v-.28c0-.364.098-.63.308-.77.196-.14.434-.224.686-.224.266 0 .546.042.854.112l.266-1.428a4.525 4.525 0 00-.798-.168 6.728 6.728 0 00-.728-.042c-.364 0-.7.056-1.008.154a2.291 2.291 0 00-.812.448 2.16 2.16 0 00-.532.798c-.14.336-.196.714-.196 1.162v.238h-1.148v1.526h1.148zm7.947-4.214V121h1.96v-9.996h-1.96zm3.718 2.688V121h1.96v-7.308h-1.96zm-.028-2.688v1.764h2.016v-1.764h-2.016zm4.209 4.214V121h1.96v-5.782h1.694v-1.526h-1.694v-.28c0-.364.098-.63.308-.77.196-.14.434-.224.686-.224.266 0 .546.042.854.112l.266-1.428a4.525 4.525 0 00-.798-.168 6.728 6.728 0 00-.728-.042c-.364 0-.7.056-1.008.154a2.291 2.291 0 00-.812.448 2.16 2.16 0 00-.532.798c-.14.336-.196.714-.196 1.162v.238h-1.148v1.526h1.148zm11.302 3.5h-1.904c-.14.658-.602.98-1.372.98-.56 0-.98-.154-1.26-.49-.28-.336-.434-.798-.448-1.386h5.068v-.784c0-1.092-.294-1.96-.854-2.604-.56-.644-1.4-.966-2.52-.966-.546 0-1.036.098-1.484.266-.448.168-.84.42-1.162.756a3.414 3.414 0 00-.742 1.232c-.182.476-.266 1.022-.266 1.638 0 1.232.294 2.184.91 2.856.616.672 1.526 1.008 2.744 1.008 1.008 0 1.764-.21 2.296-.63.532-.42.854-1.05.994-1.876zm-1.806-2.184h-3.15c0-.224.042-.42.126-.616.07-.196.168-.364.308-.504.14-.14.308-.266.504-.35.196-.084.42-.126.686-.126.518 0 .896.14 1.148.42.252.28.378.672.378 1.176z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DF4B85",
    d: "M236.779 121.645c3.743 0 6.778-3.11 6.778-6.947 0-3.836-3.035-6.946-6.778-6.946-3.744 0-6.779 3.11-6.779 6.946 0 3.837 3.035 6.947 6.779 6.947z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#DF4B85",
    d: "M236.103 112.993v5.687h.957v-5.687h-.957zm-.033-2.167v1.111h1.023v-1.111h-1.023z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCDCDC",
    strokeWidth: 0.5,
    d: "M59.398 218.026l43.945-75.783 87.603-.166 43.656 75.614-43.945 75.783-87.603.167-43.656-75.615z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCDCDC",
    strokeWidth: 0.5,
    d: "M59.398 218.026l43.945-75.783 87.603-.166 43.656 75.614-43.945 75.783-87.603.167-43.656-75.615z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCDCDC",
    strokeWidth: 0.5,
    d: "M59.398 218.026l43.945-75.783 87.603-.166 43.656 75.614-43.945 75.783-87.603.167-43.656-75.615z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCDCDC",
    strokeWidth: 0.5,
    d: "M80.123 217.928l33.189-57.235 66.162-.125 32.971 57.107-33.19 57.235-66.162.125-32.97-57.107z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCDCDC",
    strokeWidth: 0.5,
    d: "M80.123 217.928l33.189-57.235 66.162-.125 32.971 57.107-33.19 57.235-66.162.125-32.97-57.107z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCDCDC",
    strokeWidth: 0.5,
    d: "M80.123 217.928l33.189-57.235 66.162-.125 32.971 57.107-33.19 57.235-66.162.125-32.97-57.107z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCDCDC",
    strokeWidth: 0.5,
    d: "M102.902 217.572L124.98 179.5l44.011-.084 21.932 37.987-22.078 38.073-44.011.084-21.932-37.988z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCDCDC",
    strokeWidth: 0.5,
    d: "M102.902 217.572L124.98 179.5l44.011-.084 21.932 37.987-22.078 38.073-44.011.084-21.932-37.988z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCDCDC",
    strokeWidth: 0.5,
    d: "M102.902 217.572L124.98 179.5l44.011-.084 21.932 37.987-22.078 38.073-44.011.084-21.932-37.988z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCDCDC",
    strokeWidth: 0.5,
    d: "M125.502 217.807l10.717-18.482 21.365-.04 10.646 18.439-10.717 18.482-21.365.041-10.646-18.44z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCDCDC",
    strokeWidth: 0.5,
    d: "M125.502 217.807l10.717-18.482 21.365-.04 10.646 18.439-10.717 18.482-21.365.041-10.646-18.44z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCDCDC",
    strokeWidth: 0.5,
    d: "M125.502 217.807l10.717-18.482 21.365-.04 10.646 18.439-10.717 18.482-21.365.041-10.646-18.44z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCDCDC",
    strokeWidth: 0.5,
    d: "M103.41 142.379l32.802 57.114"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCDCDC",
    strokeWidth: 0.5,
    d: "M191.012 293.271l-32.803-57.115"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCDCDC",
    strokeWidth: 0.5,
    d: "M191.011 142.379l-33.188 56.729"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCDCDC",
    strokeWidth: 0.5,
    d: "M103.41 293.271l33.189-56.729"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCDCDC",
    strokeWidth: 0.5,
    d: "M234.62 217.632h-66.377"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCDCDC",
    strokeWidth: 0.5,
    d: "M125.792 217.632H59.416"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0ADC7",
    d: "M125.021 180.585l-65.218 37.047 54.027 57.887 55.185-19.682 42.45-38.205-40.134-18.523-46.31-18.524z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DF4B85",
    d: "M125.021 180.585l-65.218 37.047 54.027 57.887 55.185-19.682 42.45-38.205-40.134-18.523-46.31-18.524z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 125.793,
    cy: 179.812,
    r: 3.859,
    fill: "#DF4B85"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.96,
    cy: 219.176,
    r: 3.859,
    fill: "#DF4B85"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.444,
    cy: 274.746,
    r: 3.859,
    fill: "#DF4B85"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 170.558,
    cy: 256.222,
    r: 3.859,
    fill: "#DF4B85"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 211.465,
    cy: 218.404,
    r: 3.859,
    fill: "#DF4B85"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeDasharray: "0.1 5",
    strokeLinecap: "round",
    strokeWidth: 2.5,
    d: "M125.793 180.2l43.608-.772 64.447 37.433-55.185 57.886-76.41 18.91-21.611-76.796 45.151-36.661z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.793,
    cy: 179.814,
    r: 2.315,
    fill: "#2C2664"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.41,
    cy: 294.042,
    r: 2.315,
    fill: "#2C2664"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.027,
    cy: 217.632,
    r: 2.315,
    fill: "#2C2664"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 234.619,
    cy: 217.632,
    r: 2.315,
    fill: "#2C2664"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 169.786,
    cy: 179.814,
    r: 2.315,
    fill: "#2C2664"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 179.82,
    cy: 274.747,
    r: 2.315,
    fill: "#2C2664"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 226,
    height: 230,
    x: 278.623,
    y: 90,
    fill: "#2C2C2C",
    rx: 20
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M303.022 111.004V121h2.086v-4.2h3.962v4.2h2.086v-9.996h-2.086v3.864h-3.962v-3.864h-2.086zm13.462 10.22a4.11 4.11 0 001.526-.266c.448-.168.84-.434 1.162-.77.322-.336.574-.742.742-1.218a4.899 4.899 0 00.266-1.638c0-.588-.084-1.134-.252-1.61a3.355 3.355 0 00-.742-1.218 3.308 3.308 0 00-1.162-.77 4.497 4.497 0 00-1.54-.266c-.56 0-1.078.098-1.526.266a3.242 3.242 0 00-1.176.77 3.355 3.355 0 00-.742 1.218 4.856 4.856 0 00-.252 1.61c0 1.26.322 2.212.966 2.884.644.672 1.554 1.008 2.73 1.008zm0-1.568c-.574 0-.994-.196-1.26-.588-.28-.392-.406-.98-.406-1.736 0-.742.126-1.316.406-1.708.28-.392.7-.588 1.26-.588s.966.196 1.246.588c.28.392.42.966.42 1.708 0 .756-.14 1.33-.42 1.722-.28.406-.686.602-1.246.602zm4.235-5.964l2.128 7.308h1.876l1.316-4.816 1.302 4.816h1.904l2.128-7.308h-2.044l-1.022 4.844-1.33-4.788h-1.708l-1.4 4.788-1.022-4.844h-2.128zm15.163 1.526v3.416c0 .91.182 1.554.574 1.932.392.392.98.574 1.792.574.224 0 .476-.014.728-.042a4.62 4.62 0 00.798-.182l-.28-1.442c-.14.042-.266.07-.406.084-.14.014-.266.014-.392.014-.252 0-.462-.056-.616-.196-.168-.14-.238-.392-.238-.784v-3.374h1.68v-1.526h-1.68v-1.946h-1.96v1.946h-1.148v1.526h1.148zm8.164 6.006a4.11 4.11 0 001.526-.266c.448-.168.84-.434 1.162-.77.322-.336.574-.742.742-1.218a4.899 4.899 0 00.266-1.638c0-.588-.084-1.134-.252-1.61a3.355 3.355 0 00-.742-1.218 3.308 3.308 0 00-1.162-.77 4.497 4.497 0 00-1.54-.266c-.56 0-1.078.098-1.526.266a3.242 3.242 0 00-1.176.77 3.355 3.355 0 00-.742 1.218 4.856 4.856 0 00-.252 1.61c0 1.26.322 2.212.966 2.884.644.672 1.554 1.008 2.73 1.008zm0-1.568c-.574 0-.994-.196-1.26-.588-.28-.392-.406-.98-.406-1.736 0-.742.126-1.316.406-1.708.28-.392.7-.588 1.26-.588s.966.196 1.246.588c.28.392.42.966.42 1.708 0 .756-.14 1.33-.42 1.722-.28.406-.686.602-1.246.602zm8.287-5.964V121h1.96v-4.228c0-.196.028-.378.112-.574.084-.182.21-.35.378-.504a1.3 1.3 0 01.532-.28c.196-.056.392-.084.616-.084.322 0 .602.028.826.084l.238-1.778c-.098-.014-.21-.028-.322-.042a4.084 4.084 0 00-.462-.028 2.13 2.13 0 00-1.092.294c-.35.196-.644.476-.882.854v-1.022h-1.904zm12.202 5.026h-1.904c-.14.658-.602.98-1.372.98-.56 0-.98-.154-1.26-.49-.28-.336-.434-.798-.448-1.386h5.068v-.784c0-1.092-.294-1.96-.854-2.604-.56-.644-1.4-.966-2.52-.966-.546 0-1.036.098-1.484.266-.448.168-.84.42-1.162.756a3.414 3.414 0 00-.742 1.232c-.182.476-.266 1.022-.266 1.638 0 1.232.294 2.184.91 2.856.616.672 1.526 1.008 2.744 1.008 1.008 0 1.764-.21 2.296-.63.532-.42.854-1.05.994-1.876zm-1.806-2.184h-3.15c0-.224.042-.42.126-.616.07-.196.168-.364.308-.504.14-.14.308-.266.504-.35.196-.084.42-.126.686-.126.518 0 .896.14 1.148.42.252.28.378.672.378 1.176zm7.698 3.542V121h1.848v-4.62c0-.448-.056-.84-.168-1.204a2.3 2.3 0 00-.518-.924c-.238-.252-.546-.434-.938-.574-.392-.14-.868-.21-1.428-.21-.924 0-1.652.182-2.184.518-.546.336-.882.896-1.008 1.652l1.792.168c.112-.588.546-.882 1.33-.882.336 0 .616.084.868.252.252.168.378.476.378.924v.364l-.938.042c-.476.028-.938.07-1.386.14-.448.084-.854.21-1.218.378a2.408 2.408 0 00-.882.742c-.224.322-.336.728-.336 1.232 0 .392.056.714.196.994.126.28.294.504.518.672.224.182.476.308.77.392.294.084.602.126.938.126.56 0 1.022-.098 1.386-.308.364-.196.686-.462.98-.798zm-.042-2.338v.378c0 .308-.056.56-.168.756a1.633 1.633 0 01-.434.49c-.322.238-.728.35-1.232.35-.308 0-.532-.07-.7-.21-.168-.14-.252-.322-.252-.574 0-.154.014-.294.07-.434a.665.665 0 01.266-.336c.14-.098.336-.182.588-.252a6.75 6.75 0 01.994-.126l.868-.042zm8.617 2.296V121h1.904v-9.996h-1.96v3.416c-.322-.364-.658-.616-1.022-.756a3.25 3.25 0 00-1.078-.196c-.504 0-.938.098-1.33.28a2.915 2.915 0 00-.994.798c-.28.336-.49.742-.63 1.218s-.21.994-.21 1.554c0 1.232.252 2.184.756 2.87.504.7 1.26 1.036 2.296 1.036.952 0 1.708-.392 2.268-1.19zm-.042-2.772v.252c0 .42-.056.77-.14 1.036-.084.266-.224.49-.406.672-.308.28-.686.406-1.148.406a1.4 1.4 0 01-.602-.112 1.197 1.197 0 01-.49-.392 2.117 2.117 0 01-.336-.714c-.084-.294-.112-.658-.112-1.106 0-.392.042-.742.126-1.036.084-.28.196-.518.336-.7.14-.168.308-.308.504-.392.196-.084.392-.126.616-.126.196 0 .392.028.588.084.196.056.392.154.56.322.168.182.294.406.378.686.084.28.126.658.126 1.12z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8F8F8F",
    strokeWidth: 0.5,
    d: "M473 112l10 10"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8F8F8F",
    strokeWidth: 0.5,
    d: "M473 122l10-10"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_radial)",
    d: "M309.371 218.45l41.163-70.984 82.055-.156 40.892 70.827-41.163 70.984-82.055.156-40.892-70.827z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCDCDC",
    strokeWidth: 0.5,
    d: "M309.371 218.45l41.163-70.984 82.055-.156 40.892 70.827-41.163 70.984-82.055.156-40.892-70.827z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCDCDC",
    strokeWidth: 0.5,
    d: "M309.371 218.45l41.163-70.984 82.055-.156 40.892 70.827-41.163 70.984-82.055.156-40.892-70.827z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4A4A4A",
    strokeWidth: 0.5,
    d: "M309.371 218.45l41.163-70.984 82.055-.156 40.892 70.827-41.163 70.984-82.055.156-40.892-70.827z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCDCDC",
    strokeWidth: 0.5,
    d: "M309.371 218.45l41.163-70.984 82.055-.156 40.892 70.827-41.163 70.984-82.055.156-40.892-70.827z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCDCDC",
    strokeWidth: 0.5,
    d: "M309.371 218.45l41.163-70.984 82.055-.156 40.892 70.827-41.163 70.984-82.055.156-40.892-70.827z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCDCDC",
    strokeWidth: 0.5,
    d: "M309.371 218.45l41.163-70.984 82.055-.156 40.892 70.827-41.163 70.984-82.055.156-40.892-70.827z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCDCDC",
    strokeWidth: 0.5,
    d: "M328.788 218.359l31.085-53.606 61.968-.118 30.881 53.487-31.086 53.607-61.968.117-30.88-53.487z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCDCDC",
    strokeWidth: 0.5,
    d: "M328.788 218.359l31.085-53.606 61.968-.118 30.881 53.487-31.086 53.607-61.968.117-30.88-53.487z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCDCDC",
    strokeWidth: 0.5,
    d: "M328.788 218.359l31.085-53.606 61.968-.118 30.881 53.487-31.086 53.607-61.968.117-30.88-53.487z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCDCDC",
    strokeWidth: 0.5,
    d: "M350.13 218.026l20.675-35.654 41.215-.079 20.539 35.574-20.676 35.654-41.214.079-20.539-35.574z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCDCDC",
    strokeWidth: 0.5,
    d: "M350.13 218.026l20.675-35.654 41.215-.079 20.539 35.574-20.676 35.654-41.214.079-20.539-35.574z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCDCDC",
    strokeWidth: 0.5,
    d: "M350.13 218.026l20.675-35.654 41.215-.079 20.539 35.574-20.676 35.654-41.214.079-20.539-35.574z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCDCDC",
    strokeWidth: 0.5,
    d: "M371.304 218.245l10.031-17.3 19.998-.038 9.965 17.26-10.031 17.3-19.998.038-9.965-17.26z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCDCDC",
    strokeWidth: 0.5,
    d: "M371.304 218.245l10.031-17.3 19.998-.038 9.965 17.26-10.031 17.3-19.998.038-9.965-17.26z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCDCDC",
    strokeWidth: 0.5,
    d: "M371.304 218.245l10.031-17.3 19.998-.038 9.965 17.26-10.031 17.3-19.998.038-9.965-17.26z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCDCDC",
    strokeWidth: 0.5,
    d: "M350.588 147.578l30.732 53.51"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCDCDC",
    strokeWidth: 0.5,
    d: "M432.66 288.945l-30.732-53.51"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCDCDC",
    strokeWidth: 0.5,
    d: "M432.66 147.578l-31.094 53.148"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCDCDC",
    strokeWidth: 0.5,
    d: "M350.587 288.945l31.094-53.148"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCDCDC",
    strokeWidth: 0.5,
    d: "M473.515 218.082h-62.187"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCDCDC",
    strokeWidth: 0.5,
    d: "M371.557 218.082H309.37"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DF4B85",
    strokeDasharray: "0.1 5",
    strokeLinecap: "round",
    strokeWidth: 2.5,
    d: "M371.558 183.01l40.855-.723 60.379 35.071-51.702 54.233-71.587 17.716-20.247-71.949 42.302-34.348z"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 371.558,
    cy: 182.65,
    r: 2.169,
    fill: "#DF4B85"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.587,
    cy: 289.669,
    r: 2.169,
    fill: "#DF4B85"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 329.618,
    cy: 218.081,
    r: 2.169,
    fill: "#DF4B85"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 473.515,
    cy: 218.081,
    r: 2.169,
    fill: "#DF4B85"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 412.775,
    cy: 182.65,
    r: 2.169,
    fill: "#DF4B85"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 422.175,
    cy: 271.591,
    r: 2.169,
    fill: "#DF4B85"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(36.87833 70.50278 -70.81344 37.04083 396.143 218.081)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96385D"
  })))));
}

export default __webpack_public_path__ + "regional-panel.colors.ca0a2869.svg";
export { SvgRegionalPanelcolors as ReactComponent };